import React from 'react';
import { Common } from 'ws-scripts/modules/common';
import PropTypes from 'prop-types';

const Main = props => {
	const { vehicleViews, numberOfDays } = props;
	return (
		<Common
			render={({ labels, prefs }) => {
				const disclaimerAttributes = prefs.disclaimerLabel
					? {
							'data-toggle': 'popover',
							'data-placement': 'bottom',
							'data-content': `${labels.get(
								prefs.disclaimerLabel
							)}`
					  }
					: {};
				const daysAlias = numberOfDays === 1 ? 'DAY' : 'DAYS';
				return (
					<div
						className="alert alert-info w-auto d-inline-block py-1 px-3 my-3 mt-sm-4 mb-sm-0 ddc-font-size-small"
						{...disclaimerAttributes}
					>
						<i
							className={`ddc-icon ddc-icon-${
								prefs.icon
							} ddc-icon-size-${prefs.iconSize} mr-3`}
						/>
						<div className="float-right mt-2">
							<span>{vehicleViews} </span>
							<span>{labels.get('VIEWS_IN_THE_PAST')} </span>
							<span>{numberOfDays} </span>
							<span>{labels.get(daysAlias)} </span>
						</div>
					</div>
				);
			}}
		/>
	);
};

Main.propTypes = {
	vehicleViews: PropTypes.number.isRequired,
	numberOfDays: PropTypes.number.isRequired
};

export default Main;



// WEBPACK FOOTER //
// ./src/components/Main.jsx